import React from 'react';
import LoadingSpinner from '../LoadingSpinner';
import './PageLoadingState.css';

/**
 * PageLoadingState – shared full-page loading. Theme from config.
 */
const PageLoadingState = ({ message = 'Loading...', className = '' }) => (
  <div className={`page-loading-state ${className}`.trim()}>
    <LoadingSpinner message={message} />
  </div>
);

export default PageLoadingState;
